function passengers(passengers) {
    const that = {};
    let paxGroups = passengers;

    that.getNumberOfAdults = function() {
        return Odigeo._.size(paxGroups.ADULT);
    };

    that.getNumberOfChildren = function() {
        return Odigeo._.size(paxGroups.CHILD);
    };

    that.getNumberOfInfants = function() {
        return Odigeo._.size(paxGroups.INFANT);
    };

    return that;
}

module.exports = passengers;
